/*
 * @Author: Json Chen
 * @Date: 2021-07-14 17:01:11
 * @LastEditTime: 2021-09-26 15:04:17
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DeliveryMethod/Components/ShippingZonePage.tsx
 */

import React, { useState } from 'react';

import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import {
  useCalcAreaText,
  useStoreCountries,
} from '@/src/pages/Settings/Components/SelectCountryArea';
import { CaretDownOutlined, PlusOutlined } from '@ant-design/icons';
import { Form, Spin } from 'antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import ShippingZoneModal, {
  useShippingZoneOptionsModal,
} from './ShippingZoneModal';

import styles from '../css.module.less';

const ShippingZone = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [selected, setSelected] = useState([]);
  const { list = [] } = useStoreCountries();
  const {
    loading: getShippingZoneListLoading,
    list: selectOptions,
    reFresh: reFresh,
  } = useShippingZoneOptionsModal();

  const onSelectChange = (v) => {
    setSelected(v);
  };

  const extraText = useCalcAreaText(selected?.countryAreas || [], list);

  return (
    <React.Fragment>
      <div className={styles.itemBlock}>
        <div className={styles.header}>
          <div className={styles.title}>
            {getI18n('storeLogistics.index.shippingZone')}
          </div>
        </div>
        <Spin spinning={getShippingZoneListLoading}>
          <div
            className={`${styles.shippingZone} ${styles.itemContent} ${styles.content}`}>
            <Form.Item
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.index.shippingZone')}*
                </div>
              }
              extra={
                extraText ? (
                  <div className={styles.extraText}>{extraText}</div>
                ) : null
              }
              name={'shippingZone'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <SelectObjectAsValue
                objectAsValue
                labelKey={'name'}
                valueKey={'uuid'}
                options={selectOptions}
                onChange={onSelectChange}
                size='large'
                className={styles.shippingZoneInput}
                notFoundContent={
                  <div>
                    {getI18n(
                      'storeLogistics.deliveryMethod.indexNotFoundContent',
                    )}
                  </div>
                }
                suffixIcon={
                  <CaretDownOutlined className={styles.selectIcon} />
                }></SelectObjectAsValue>
            </Form.Item>
            <ShippingZoneModal
              list={list}
              selectOptions={selectOptions}
              onSuccess={reFresh}>
              <PlusOutlined />
            </ShippingZoneModal>
          </div>
        </Spin>
      </div>
    </React.Fragment>
  );
};

export default ShippingZone;
